import React from 'react'

type PropTypes = {
  currentUser: Object,
  announcements: Array<Object>,
}

class ServiceMessages extends React.Component {
  constructor(props: PropTypes) {
    super(props)
  }

  render() {
    if (!this.props.announcements || !this.props.announcements.length) {
      return null
    }
    let rows = []
    for (
      let rowIndex = 0;
      rowIndex < this.props.announcements.length;
      rowIndex++
    ) {
      const announcement = this.props.announcements[rowIndex]
      const className = 'is-new site-header__nav-baloon-menu clearfix'
      rows.push(
        <li className={className} key={rowIndex}>
          <a
            href={announcement.link}
            data-tag={rowIndex}
            className="link-black link-borderless"
          >
            <p className="site-header__nav-baloon-message-content">
              {announcement.content}
            </p>
          </a>
        </li>,
      )
    }
    return (
      <div>
        <h2 key="title" className="site-header__nav-baloon-title">
          スペースマーケットからのお知らせ
        </h2>
        <ul>{rows}</ul>
      </div>
    )
  }
}

export default ServiceMessages



// WEBPACK FOOTER //
// ./src/components/shared/header/ServiceMessages.jsx